import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import useStateFromProps from '@/hooks/useStateFromProps';
import { debounce } from 'lodash-es';
import { Input } from 'antd';
import globalStore from '@/store/global';
import "./index.scss";

function CompositionInput(props, ref) {
  const { 
    className, 
    debounceWait = 0, 
    placeholder = '', 
    onChange = () => {},
    onPressEnter = () => {},
    isTextarea = false,
    value:inputValue,
    bordered, // 标记已弃用的属性
    ...inputProps
  } = props;

    // 将 bordered 属性转换为 variant 属性
  const variantProp = bordered === false ? { variant: "borderless" } : {};

  const [value, setValue] = useStateFromProps({ value: props.value || '' });
  const [isComposition, setComposition] = useState(false);
  const inputRef = useRef(null);

  const handleChange = useCallback(
    debounce(value => onChange?.(value), debounceWait),
    [debounceWait]
  );

  const handleInputChange = (event) => {
    const value = event.target.value;
    setValue(value);
    if(!isComposition){
      handleChange(value);
    }
  }

  const handleComposition = (event) => {
    if (event.type === 'compositionend') {
      setComposition(false);
      handleChange(event.target.value);
    } else {
      setComposition(true);
    }
  }

  const handlePressEnter = (event) => {
    if(isComposition){
      return;
    }
    onPressEnter(event);
  }

  useImperativeHandle(
    ref,
    () => ({
      clear: () => setValue(''),
      focus: () => inputRef.current?.focus(),
      focused: () => {
        return inputRef.current.input == document.activeElement;
      },
      blur: () => inputRef.current?.blur(),
      setValue: (value) => { inputRef.current.value = value },
    }),
    []
  );

  useEffect(() => { 
    if(!inputValue){
      setValue("");
    }
  }, [inputValue]);

  if(isTextarea){
    return (
      <Input.TextArea
        ref={inputRef}
        className={['composition-input composition-textarea', globalStore.isDark ? '!bg-input-bg-normal' : '!bg-[#F6F7F9]', className]}
        placeholder={placeholder}
        value={value}
        onCompositionUpdate={handleComposition}
        onCompositionEnd={handleComposition}
        onChange={handleInputChange}
        onPressEnter={handlePressEnter}
        {...variantProp} // 使用转换后的 variant 属性
        {...inputProps}
      />
    );
  }

  return (
    <Input
      ref={inputRef}
      className={['composition-input', globalStore.isDark ? '!bg-input-bg-normal' : 'bg-[#F6F7F9]', className]}
      type="text"
      autoComplete="off"
      placeholder={placeholder}
      value={value}
      onCompositionUpdate={handleComposition}
      onCompositionEnd={handleComposition}
      onChange={handleInputChange}
      onPressEnter={handlePressEnter}
      {...inputProps}
    />
  );
}

export default forwardRef(CompositionInput);
